import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type SiteDeploymentNotFoundErrorOptions = {
  deployment: ObjectId;
};

export class SiteDeploymentNotFoundError extends FleekError<SiteDeploymentNotFoundErrorOptions> {
  public name = 'SiteDeploymentNotFoundError';

  toString = () => `Deployment not found.`;
}
